/**
 * Image Listener
 *
 * Registers DOM event listeners for the image picker workflow.
 */

import { ImageHandler } from "./image-handler";
import { imageForm } from "./image-form";

class ImageListener {
    public static setupFileInputListener(handler: InstanceType<typeof ImageHandler>): void {
        handler.fileInput.addEventListener("change", (event: Event) => {
            const target = imageForm.getEventInput(event);
            if (!target) return;
            ImageHandler.handleFileSelection(handler, Array.from(target.files || []));
            target.value = "";
        });
    }

    public static setupAddButtonListener(handler: InstanceType<typeof ImageHandler>): void {
        handler.addBtn.addEventListener("click", () => {
            handler.fileInput.click();
        });
    }

    public static setupCreateModeClickListeners(handler: InstanceType<typeof ImageHandler>): void {
        handler.container.addEventListener("click", (event: Event) => {
            const target = imageForm.getEventTarget(event);
            if (!target) return;
            if (imageForm.getClosestRotateTrigger(target)) {
                ImageHandler.handleCreateModeImageRotation(handler, event);
            }

            if (imageForm.getClosestRemoveTrigger(target)) {
                ImageHandler.handleCreateModeImageRemoval(handler, event);
            }
        });
    }

    public static setupEditModeClickListeners(handler: InstanceType<typeof ImageHandler>): void {
        handler.container.addEventListener("click", (event: Event) => {
            const target = imageForm.getEventTarget(event);
            if (!target) return;

            if (imageForm.getClosestRotateTrigger(target) && imageForm.getExistingImageItemTile(target)) {
                ImageHandler.handleExistingImageRotation(handler, event);
            }

            if (imageForm.getClosestRemoveTrigger(target) && imageForm.getExistingImageItemTile(target)) {
                ImageHandler.handleExistingImageRemoval(handler, event);
            }

            if (imageForm.getClosestRotateTrigger(target) && imageForm.getNewImageTile(target)) {
                ImageHandler.handleNewImageRotation(handler, event);
            }

            if (imageForm.getClosestRemoveTrigger(target) && imageForm.getNewImageTile(target)) {
                ImageHandler.handleNewImageRemoval(handler, event);
            }
        });
    }

    public static setupDragAndDrop(_handler: InstanceType<typeof ImageHandler>, _dropArea: HTMLElement): void {
        return;
    }
}

export { ImageListener };
